import api from "@/services/api";
import { realityId } from "@/utils/reality-id";
import type { InscriptionStatusResponse } from "./types";

export async function getInscriptionStatus(): Promise<InscriptionStatusResponse> {
  const res = await api.get<InscriptionStatusResponse>(
    `/realities/${realityId}/inscription-status`
  );
  return res.data;
}
